import { Header, HeaderProps } from '@rossum/components/header/Header';
import { HeaderTabs } from '../../../components/NavBar/HeaderTabs';
import { tabs } from '../../../components/NavBar/navigationStructure';

type ExtensionsPageKeys =
  | 'rossumStore'
  | 'externalStore'
  | 'myExtensions'
  | 'activities';

type ExtensionsHeaderProps = {
  value: ExtensionsPageKeys;
  description?: HeaderProps['description'];
} & Pick<HeaderProps, 'scrollableDivRef' | 'title' | 'buttons'>;

export const ExtensionsHeader = ({
  value,
  ...params
}: ExtensionsHeaderProps) => (
  <Header
    {...params}
    description={null}
    breadcrumbs={null}
    tabs={
      <HeaderTabs
        dataCy="extensions-tabs"
        menuItems={tabs.find(tab => tab.name === 'extensions')?.menu ?? []}
        value={value}
      />
    }
  />
);
